import { useState } from "react";
import DashboardLayout from "../../../shared/DashboardLayout";
import SearchCaExpenseTable from "./SearchCaExpensesTable";
import Pagination from "../../../shared/Pagination";
import { searchCAExpensePills } from "../../../mock/SearchCAExpenses";
import SearchCaExpensesForm from "./SearchCaExpensesForm";

const SearchCaExpenses = () => {
  const [toggleFilters, setToggleFilters] = useState(true);

  const handleToogleFilters = () => {
    setToggleFilters(!toggleFilters);
  };

  return (
    <DashboardLayout>
      <div className="mb-4 p-0 p-sm-3">
        <div className="section_top d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center my-3">
          <div className="mb-3 mb-md-0">
            <h2 className="my-2 me-3 d-inline-block">
              <span>Search Expenses</span>
            </h2>
            <button
              className="btn site_btn text-white my-2 me-2"
              onClick={handleToogleFilters}
            >
              Toggle Filters
            </button>
          </div>

          <div className="d-flex align-items-center mt-2 mt-md-0">
            <span className="me-2">Items Per Page</span>
            <input
              type="number"
              name="item_number"
              value="20"
              className="form-control w-50"
              disabled
            />
          </div>
        </div>

        <SearchCaExpensesForm toggleFilters={toggleFilters} />

        <Pagination />

        <div className="d-block d-sm-flex justify-content-between my-4">
          <div>
            {searchCAExpensePills.map((item) => (
              <button
                className={`mb-2 ms-2 btn btn-${item.variant} wt-disable-link`}
                key={item.id}
              >
                {item.title}
                <span className="badge badge-pill badge-light mx-2">
                  {item.value}
                </span>
              </button>
            ))}
          </div>
          <button className="btn btn-outline-primary mb-2 mr-2 btn btn-outline-primary page-title-action">
            Export
          </button>
        </div>

        <SearchCaExpenseTable />

        <Pagination />
      </div>
    </DashboardLayout>
  );
};

export default SearchCaExpenses;
